import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { LuArrowLeft } from "react-icons/lu";
import { NavLink } from "react-router-dom";
import { images } from "../../config";
import './ConfirmPassword.css';

const ConfirmPassword = () => {

    return (
        <>
            <Container maxWidth="xxl" sx={{ padding: { lg: 0, xs: 0 } }} >
                <Grid container >
                    <Grid item xs={12} sm={12} md={12} lg={5}>
                        <div
                            className='sign-in-text-wrap'
                        >
                            <div className='sign-in-text'>
                                <div>
                                    <img src={images.iSecureLogo} alt="image" className='i-secure-logo' />
                                </div>
                                <div className='sign-in-text'>
                                    <h2>Password Reset</h2>
                                    <h6 style={{ fontWeight: 600 }}>Your password has been successfully reset<br></br> Click below to login magically<br></br>
                                    </h6>
                                </div>
                                <div className='back-to-login-btn'>
                                    <NavLink to="/login">
                                        <button>  <LuArrowLeft className='' /> Back to login</button>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={7}>
                        <img
                            src={images.loginImg}
                            alt="image"
                            className='main-img'
                        />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

export default ConfirmPassword;